import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import {ConfirmModule} from "../../modules/confirm/confirm.module";
import {NotesService} from "../../models/notes/notes.service";
import {NotesComponent} from "../../modules/notes/notes.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { MentionModule } from 'angular2-mentions/mention';

@NgModule({
    entryComponents: [
    ],
    imports: [
        ConfirmModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MentionModule
    ],
    exports:[
        NotesComponent
    ],
    declarations: [
        NotesComponent
    ],
    providers: [
        NotesService
    ]
})

export class NotesModule {

}



// WEBPACK FOOTER //
// ./src/app/modules/notes/notes.module.ts